module.exports = __webpack_public_path__ + "token-offers.55ee8488.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/community_tabs/token-offers.png
// module id = 345
// module chunks = 0